module.exports = __webpack_public_path__ + "59aef08222d5fd3021fb0844422270b2.jpg";